import { Subscription } from '@models/membership/Subscription'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  selectSubscriptionById,
  updateSubscriptionTags,
} from '@store/membership/SubscriptionReducer'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Entity } from '@utils/Entities'
import { App, Form, Space } from 'antd'
import { FC, useState } from 'react'
import { DEFAULT_SUCCESS } from '../../../App'
import SubscriptionTag from '../subscription-tag/SubscriptionTag'

type Props = SBModelComponent<Subscription> & {
  onChange?: () => void
}

const TagManager: FC<Props> = ({ id, model, onChange }: Props) => {
  const { message } = App.useApp()

  const dispatch = useAppDispatch()
  const item = model ? model : useAppSelector(selectSubscriptionById(id!))

  const [isLoading, setIsLoading] = useState<boolean>(false)

  if (!item) {
    return <></>
  }

  const handleTagChange = (values: number[]) => {
    setIsLoading(true)
    dispatch(updateSubscriptionTags({ ...item, tags: values }))
      .then(() => {
        message.success(DEFAULT_SUCCESS)
        onChange?.()
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <Form
      className="w-full"
      layout="horizontal"
      initialValues={{ tags: item.tags }}
    >
      <Space.Compact className="w-full">
        <Form.Item name={'tags'} noStyle className="w-full">
          <SBAsyncSelect
            style={{ minWidth: '12ch' }}
            multiple
            entity={Entity.subscriptionTag}
            allowClear
            disabled={isLoading}
            inlineEdit={{
              renderSelection: () =>
                (item.tags ?? []).map((tag) => (
                  <SubscriptionTag.Tag key={tag} id={tag} />
                )),
            }}
            onChange={handleTagChange}
          />
        </Form.Item>
      </Space.Compact>
    </Form>
  )
}

type TagManagerType = {
  TagManager: typeof TagManager
}
export { TagManager, type TagManagerType }
